<template>
  <div class="data-table">
    <div class="d-header">
        <div class="pull-left seek">
          <dropdown class="pull-left" ref="dropdown">
            <button data-role="trigger" class="btn btn-default dropdown-toggle dropBtn" type="button">
              <span>{{tableModelLan[seekKey.active]}}</span>
              <span class="caret"></span>
            </button>
            <template slot="dropdown">
              <li v-for="(item,index) in seekKey.list" @click="$emit('handleChangeSeekKey',item)"><a role="button">{{tableModelLan[item]}}</a></li>
            </template>
          </dropdown>
          <div class="pull-left form-group" style="margin-bottom: 0">
            <input type="text" class="form-control seek-input" :placeholder="tableModelLan.search" v-model="seekVal" @keyup.enter="handleSeek" @blur="handleSeek">
          </div>
          <div class="pull-left btn btn-primary seekBtn" @click="handleSeek">{{tableModelLan.search}}</div>
          <div class="clear"></div>
        </div>
        <div class="pull-left btn-group">
          <btn-group>
            <btn @click="$emit('refresh')"><i class="fa fa-refresh" aria-hidden="true"></i> {{tableModelLan.btnGroup[btnGroup.refresh]}}</btn>
            <btn @click="$emit('toAdd')" :disabled="viewReadOnly"><i class="fa fa-user-plus" aria-hidden="true"></i> {{tableModelLan.btnGroup[btnGroup.add]}}</btn>
            <btn @click="$emit('toDelete')" :disabled="viewReadOnly" v-if="!confirmDelete" class="delete-btn"><i class="fa fa-user-times" aria-hidden="true"></i> {{tableModelLan.btnGroup[btnGroup.delete]}}</btn>
            <btn @click="$emit('toConfirmDelete')" :disabled="viewReadOnly" v-else class="delete-btn"><i class="fa fa-sign-out" aria-hidden="true"></i></i> {{tableModelLan.btnGroup[btnGroup.confirmDelete]}}</btn>
          </btn-group>
        </div>
        <div class="pull-right tool-selPage">
          <span>{{tableModelLan.showclausesnum}}</span>
          <dropdown menu-right>
            <btn class="dropdown-toggle">
              {{selPage.list[selPage.active]}}
              <span class="caret" style="margin-left:5px;"></span>
            </btn>
            <template slot="dropdown" v-for="(item,index) in selPage.list">
              <li @click="emitSelPage(index,item)"><a role="button">{{item}}</a></li>
            </template>
          </dropdown>
        </div>
        <div class="clear"></div>
    </div>
    <div class="d-section">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th v-for="(thead,index) in theadText" >{{thead}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tbody,tbodyIndex) in tbodyData">
            <td v-for="(key,keyIndex) in Object.keys(tbody)" v-html="
              (key ==='enable' || key === 'changed') ? tableModelLan.enable[tbody[key]] : 
              key ==='functions'? formatData(tbody[key].split('; ')) :
              tbody[key]" 
              v-if="keyIndex < Object.keys(tbody).length"
              :style="key === 'functions' ? 'width: 40%' : ''"
              ></td>
            <td  v-show="!confirmDelete" class="last-td">
              <i class="fa fa-pencil-square-o" aria-hidden="true" @click="$emit('toEdit',tbody[viewKey])"></i>
              <i class="fa fa-sort" aria-hidden="true" v-if="!viewReadOnly" v-show="viewKey === 'providerId'" @click="$emit('handleSort',tbody)" style="margin-left: 10px;"></i>
            </td>
            <td v-if="!viewReadOnly" v-show="confirmDelete&&!deleteDataKeys.includes(tbody[viewKey])" @click="$emit('hanldeDelete',tbodyIndex)" class="last-td">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </td>
            <td v-if="!viewReadOnly" v-show="confirmDelete&&deleteDataKeys.includes(tbody[viewKey])" @click="$emit('hanldeChecked',tbodyIndex)" class="last-td">
              <i class="fa fa-check" aria-hidden="true" style="color: red"></i>
            </td>
          </tr>
          
        </tbody>
      </table>
      <div class="noData" v-if="tbodyData.length === 0"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>{{tableModelLan.noData}}</div>
    </div>
    <div class="d-footer">
      <div class="pull-left number-entries">
        {{tableModelLan.clausesamount}}{{page.pageLeng}} 
        {{tableModelLan.present}}{{page.active*selPage.limit-selPage.limit+1}}-{{Math.min(page.active*selPage.limit,page.pageLeng)}}
      </div>
      <div class="pull-right">
        <pagination v-model="page.active" :total-page="Math.ceil(page.pageLeng/selPage.limit)" boundary-links @change="callpageFn" style="height: 32px;"></pagination>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { Dropdown, BtnGroup, Btn, Pagination } from "uiv"
export default {
  mixins: [require("common/mixin/base.js").base({tableModelLan:"tableModel"})],
  props: {
    viewReadOnly: {
      type: Boolean,
      default: false
    },
    viewKey: {
      type: String,
      default: '',
    },
    btnGroup:{
      type: Object,
      default: {},
    },
    seekKey: {
      type: Object,
      default: {}
    },
    theadText: {
      type: Array,
      default: [],
    },
    tbodyData: {
      type: Array,
      default: [],
    },
    confirmDelete: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: {}
    },
    selPage: {
      type: Object,
      default: {}
    },
    deleteDataKeys: {
      type: Array,
      default: null
    }
  },
  components: {
    Dropdown,
    BtnGroup,
    Btn,
    Pagination
  },
  data() {
    return {}
  },
  computed: {
    seekVal: {
      get() {
        return this.seekKey.seekVal
      },
      set(val) {
        this.$emit('handleChangeSeekVal',val)
      }
    }
  },
  methods: {
    handleSeek() {
      this.$parent.page.active = 1
      this.$emit('handleSeek')
    },
    
    emitSelPage(index, item) { // 选择一页显示的条目数量
      this.$emit("selPage", index, item)
    },
    callpageFn(index) { // 翻页回调
      this.$emit('pagingFn',index)
    },
    formatData(arr) { // 专门处理角色管理页面的表格,可以显示“只读”的翻译
      let newArr = []
      arr.filter(v => {
        if(v.indexOf('_readOnly')!== -1) {
          let a = v.split('_readOnly')[0]
          v = a + `(${this.tableModelLan.readOnly})`
        }
        newArr.push(v)
      })
      return newArr.join('; ')
    }
  },
}
</script>


<style lang="scss" scoped>
.data-table{
  .d-header{
    padding: 20px 20px 25px;
    line-height: 34px;
    >.seek{
      .dropBtn{
        border-right: none;
        border-radius: 4px 0 0 4px;
      }
      .seek-input{
        border-radius: 0;
      }
      .seekBtn{
        border-left: none;
        border-radius: 0 4px 4px 0;
      }
    }
    >.btn-group{
      margin-left: 30px;
      .delete-btn{
        color: #fff;
        background-color: #f44336;
        border-color: #f44336
      }
    }
  }
  .d-section{
    .table-bordered{
      border: 0;
      border-top: 0;
      border-collapse: collapse;
    }
    .table thead{
      border-top: 1px solid #ddd;
      tr th,tr td{
        border-bottom: 1px solid #bbb;
      }
      tr th {
        font-weight: normal;
      }
    }
    .table thead tr td:first-child, .table thead tr th:first-child, .table tbody tr td:first-child{
      border-left: 0;
    }
    .table thead tr td:last-child, .table thead tr th:last-child, .table tbody tr td:last-child{
      border-right: 0;
    }
    .table tbody tr .last-td{
      text-align: center;
      font-size: 16px;
      cursor: pointer;
      color: #000;
      width: 8%;
    }
    .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
      padding: 12px 20px;
      line-height: 1.5384616;
      vertical-align: top;
      border-top: 1px solid #ddd;
    }
    .noData{
      font-size: 16px;
      text-align: center;
      i{
        margin-right: 5px;
      }
    }
  }
  .d-footer{
    padding: 0 20px 20px;
    .number-entries{
      line-height: 32px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/dataTable.vue